<template>
    <td-dialog :title="$t('pgCommon.UPGRADE_PLUGIN')" :visible="dialogVisible" width="40%" :before-close="upgradeDialogClose" :close-on-click-modal="false" :close-on-press-escape="false" v-dialogDrag>
        <fieldset>
            <legend>{{ $t('pgCommon.UPLOAD_UPGRADE_PLUGIN') }}</legend>
            <el-col :span="24">
                <td-upload
                    message="common.ONLYUPLOADZIPFILEONLYONE"
                    ref="upload"
                    :on-remove="onRemove"
                    :file-list="fileList"
                    accept=".zip"
                    :with-credentials="withCredentials"
                    :autoUpload="true"
                    :limit="limit"
                    :on-exceed="handleExceed"
                    :on-change="handChange"
                    multiple
                    :http-request="uploadUpgrade"
                >
                </td-upload>
            </el-col>
        </fieldset>
        <fieldset>
            <legend>{{ $t('pgCommon.UPGRADE_PLUGIN_PACKAGE_INFO') }}</legend>
            <el-row :gutter="20">
                <el-col :span="3"
                    ><div class="grid-content">{{ $t('common.ID') }}</div></el-col
                >
                <el-col :span="9"><div ref="id" class="grid-content"></div></el-col>
                <el-col :span="3"
                    ><div class="grid-content">{{ $t('pgCommon.NAME') }}</div></el-col
                >
                <el-col :span="9"><div ref="name" class="grid-content"></div></el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :span="3"
                    ><div class="grid-content">{{ $t('common.VERSION') }}</div></el-col
                >
                <el-col :span="9"><div ref="version" class="grid-content"></div></el-col>
                <el-col :span="3"
                    ><div class="grid-content">{{ $t('common.AUTHOR') }}</div></el-col
                >
                <el-col :span="9"><div ref="author" class="grid-content"></div></el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :span="3">
                    <div class="grid-content">{{ $t('common.DESCRIPTION') }}</div>
                </el-col>
                <el-col :span="21">
                    <div ref="describe" class="grid-content"></div>
                </el-col>
            </el-row>
        </fieldset>
        <fieldset style="height:230px">
            <legend>{{ $t('pgCommon.SELECT_PLUGIN_UPGRADE_ITEM') }}</legend>
            <el-form v-if="formUpgradeInfo.pluginId != ''" :model="formUpgradeInfo" :rules="rules" label-width="15%">
                <el-form-item :label="$t('pgCommon.PLUGIN_UPGRADE_WEB')" prop="WEB">
                    <td-switch v-model="formUpgradeInfo.upgradeDir.WEB" :activeText="$t('pgCommon.PLUGIN_UPGRADE_YES')" :inactiveText="$t('pgCommon.PLUGIN_UPGRADE_NO')"></td-switch>
                </el-form-item>
                <el-form-item :label="$t('pgCommon.PLUGIN_UPGRADE_LIB')" prop="LIB">
                    <td-switch v-model="formUpgradeInfo.upgradeDir.LIB" :activeText="$t('pgCommon.PLUGIN_UPGRADE_YES')" :inactiveText="$t('pgCommon.PLUGIN_UPGRADE_NO')"></td-switch>
                </el-form-item>
                <el-form-item :label="$t('pgCommon.PLUGIN_UPGRADE_RESOURCES')" prop="RESOURCES">
                    <td-switch v-model="formUpgradeInfo.upgradeDir.RESOURCES" :activeText="$t('pgCommon.PLUGIN_UPGRADE_YES')" :inactiveText="$t('pgCommon.PLUGIN_UPGRADE_NO')"></td-switch>
                </el-form-item>
                <el-form-item :label="$t('pgCommon.PLUGIN_UPGRADE_SQL')" prop="SQL">
                    <td-switch v-model="formUpgradeInfo.upgradeDir.SQL" :activeText="$t('pgCommon.PLUGIN_UPGRADE_YES')" :inactiveText="$t('pgCommon.PLUGIN_UPGRADE_NO')" disabled="true"></td-switch>
                    <label style="margin-left:40px;color:#FF0000">{{ $t('pgCommon.PLUGIN_NOT_SUPPORT_UPGRADE_DB') }}</label>
                </el-form-item>
            </el-form>
        </fieldset>
        <div slot="footer" class="dialog-footer">
            <td-button type="primary" :loading="addFormLoading" @click="submitForm('addForm')">{{ $t('common.INSTALL') }}</td-button>
            <td-button @click="cancel">{{ $t('common.CANCEL') }}</td-button>
        </div>
    </td-dialog>
</template>
<style scoped>
.el-row {
    height: 40px;
}
.grid-content {
    height: 40px;
    line-height: 20px;
}
</style>
<script>
import pluginApi from './../assets/api.js';
export default {
    props: ['dialogVisible', 'baseUrl'],
    data() {
        return {
            uploadTip: '', // 上传插件按钮文字描述
            fileList: [], // 上传文件集合
            withCredentials: true, // 支持发送 cookie 凭证信息
            describe: '',
            depends: '',
            fileUploadVo: {
                fileName: '', // 文件名称
                fullName: '', // 文件完整名称
                basePath: '', // 文件存储基础路径
                fileSize: null // 文件大小
            },
            limit: 1, // 限制上传文件数量
            addFormLoading: false,
            // 选择的更新项目表单信息
            formUpgradeInfo: {
                pluginId: '',
                fileName: '',
                upgradeDir: {
                    WEB: false,
                    LIB: false,
                    RESOURCES: false,
                    SQL: false
                }
            }
        };
    },
    mounted() {
        this.initData();
    },
    methods: {
        // 页面初始化方法
        initData() {
            this.fileList = [];
            this.uploadTip = this.$t('common.UPLOADPLUGIN');
        },
        // dialog关闭前必调用的方法
        upgradeDialogClose() {
            this.$emit('upgradeDialogClose');
        },
        // 点击取消
        cancel() {
            this.upgradeDialogClose();
        },
        // 本地选择文件时触发事件
        handChange(file, fileList) {
            this.fileList = fileList;
        },
        // 上传数量限制方法
        handleExceed(files, fileList) {
            this.$message.warning(this.$t('message.NOW_LIMIT_CHOOSE') + this.limit + this.$t('message.GE_FILE_'));
        },
        // 点击文件列表叉号触发事件
        onRemove(file, fileList) {
            this.formUpgradeInfo.pluginId = '';
            this.formUpgradeInfo.fileName = '';
            this.formUpgradeInfo.upgradeDir.WEB = false;
            this.formUpgradeInfo.upgradeDir.LIB = false;
            this.formUpgradeInfo.upgradeDir.RESOURCES = false;

            this.$refs.id.innerHTML = ''; // 插件ID
            this.$refs.name.innerHTML = ''; // 插件名称
            this.$refs.describe.innerHTML = ''; // 插件描述
            this.$refs.version.innerHTML = ''; // 插件版本
            this.$refs.author.innerHTML = ''; // 插件授权
        },
        // 自定义上传文件方法
        uploadUpgrade(content) {
            let file = content.file;
            let fd = new FormData();
            fd.append('multipartFile', file);
            fd.append('fileName', this.fileUploadVo.fileName);
            let i = 0;
            pluginApi.uploadUpgradeFile(fd, response => {
                if (i > 0) {
                    return;
                }
                i++;
                if (response.status === window.pgCommon.login.RESPONSE_STATUS && response.data) {
                    if (response.data.statusCode === window.pgCommon.requestCode.SUCCESS_INFO_CODE) {
                        content.onSuccess(response.data);
                        this.setPluginInfo(response.data.content);
                        this.$refs.upload.clearFiles();
                    } else {
                        this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                        this.$log.error('/plugin/uploadUpgrade', response.data.statusMessage);
                        this.$refs.upload.clearFiles();
                    }
                } else {
                    this.$message({ showClose: true, message: this.$t('common.OPERATION_FAIL'), type: 'error' });
                    this.$log.error('/plugin/uploadUpgrade', response);
                    this.$refs.upload.clearFiles();
                }
            });
        },
        // 给页面插件信息赋值
        setPluginInfo(content) {
            this.formUpgradeInfo.pluginId = content.pluginDescriptorVo.pluginId;
            this.formUpgradeInfo.fileName = content.fileName;
            this.formUpgradeInfo.upgradeDir.WEB = true;
            this.formUpgradeInfo.upgradeDir.LIB = true;
            this.formUpgradeInfo.upgradeDir.RESOURCES = true;

            this.$refs.id.innerHTML = content.pluginDescriptorVo.pluginId; // 插件id
            this.$refs.name.innerHTML = content.pluginDescriptorVo.pluginName; // 插件名称
            this.$refs.version.innerHTML = content.pluginDescriptorVo.version; // 插件版本
            this.$refs.author.innerHTML = content.pluginDescriptorVo.provider; // 插件授权
            this.$refs.describe.innerHTML = content.pluginDescriptorVo.pluginDescription; // 插件描述
            this.$refs.depends.innerHTML = content.pluginDescriptorVo.dependenciesStr; // 插件依赖
        },
        // 点击确定
        submitForm() {
            this.addFormLoading = true;
            if (this.formUpgradeInfo.pluginId == '') {
                this.$message({ showClose: true, message: this.$t('message.PLEASE_CHOOSE_ZIP'), type: 'warning' });
                this.addFormLoading = false;
                return;
            }

            var _this = this;
            let json = JSON.stringify(this.formUpgradeInfo);

            pluginApi.upgradePlugin(json, response => {
                if (response.status === window.pgCommon.login.RESPONSE_STATUS && response.data) {
                    if (response.data.statusCode === window.pgCommon.requestCode.SUCCESS_INFO_CODE) {
                        if (response.data.content) {
                            _this.$message({ showClose: true, message: this.$t('pgCommon.UPDATE_SUCCESS'), type: 'success' });
                            setTimeout(() => {
                                _this.$emit('querypluginLIst');
                                _this.upgradeDialogClose();
                                _this.addFormLoading = false;
                            }, 1000);
                        } else {
                            _this.$message({ showClose: true, message: response.data.statusMessage, type: 'success' });
                            setTimeout(() => {
                                _this.$emit('querypluginLIst');
                                _this.upgradeDialogClose();
                                _this.addFormLoading = false;
                            }, 1000);
                        }
                    } else {
                        _this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                        _this.$log.error('/plugin/upgrade', response.data.statusMessage);
                        _this.addFormLoading = false;
                    }
                } else {
                    _this.$message({ showClose: true, message: this.$t('common.OPERATION_FAIL'), type: 'error' });
                    _this.$log.error('/plugin/upgrade', response);
                    _this.addFormLoading = false;
                }
            });
        }
    }
};
</script>
